var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71476 6.54257L3.343 7.91432C2.17143 9.0859 2.17143 10.9854 3.343 12.157C4.51457 13.3285 6.41407 13.3285 7.58564 12.157L9.41407 10.3285C10.5856 9.15697 10.5856 7.25747 9.41407 6.0859C9.16613 5.83796 8.88559 5.64249 8.58625 5.4995L7.99985 6.0859C7.93888 6.14688 7.88742 6.21377 7.84548 6.28473C8.16092 6.37512 8.4585 6.54454 8.70696 6.793C9.48801 7.57405 9.48801 8.84038 8.70696 9.62143L6.87853 11.4499C6.09749 12.2309 4.83116 12.2309 4.05011 11.4499C3.26906 10.6688 3.26906 9.40248 4.05011 8.62143L4.84271 7.82883C4.73052 7.4087 4.68787 6.97387 4.71476 6.54257Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58564 4.67168C5.41407 5.84326 5.41407 7.74275 6.58564 8.91432C6.83358 9.16226 7.11411 9.35773 7.41345 9.50072L8.18905 8.72513C7.86071 8.63744 7.55034 8.46481 7.29275 8.20722C6.5117 7.42617 6.5117 6.15984 7.29275 5.37879L9.12118 3.55036C9.90222 2.76931 11.1686 2.76931 11.9496 3.55036C12.7307 4.33141 12.7307 5.59774 11.9496 6.37879L11.157 7.1714C11.2692 7.59152 11.3118 8.02635 11.2849 8.45766L12.6567 7.0859C13.8283 5.91432 13.8283 4.01483 12.6567 2.84326C11.4851 1.67168 9.58564 1.67168 8.41407 2.84326L6.58564 4.67168Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkButton);
export default __webpack_public_path__ + "static/media/linkButton.2b4251c12a925748f0a946c48d92a2c1.svg";
export { ForwardRef as ReactComponent };